export enum TableRow {
  Id = "id",
  Name  = "name",
  Price = "price",
}